import React from 'react'
import { IonHeader, IonToolbar, IonTitle, IonContent } from '@ionic/react'

interface Props {
  
}

const CustomerInfo: React.FC<Props> = () => {
  return (
    <React.Fragment>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Hello tomorrow</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <p>Work bitch</p>
      </IonContent>
    </React.Fragment>
  )
}

export default CustomerInfo
